import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import TaskDetails from '../../container/admin/TaskDetails';
import TaskStatusManager from '../../container/admin/TaskStatusManager';
import LeaveRequestManage from '../../container/admin/LeaveRequestManage';
import AddLeave from '../../container/admin/AddLeave';
// // import EmployeeDailyWork from '../../container/admin/EmployeeDailyWork';
// import LeaveCalendar from '../../container/admin/LeaveCalendar';
// import Product from '../../container/admin/Product';
const EmployeeDailyWork = lazy(() => import('../../container/admin/EmployeeDailyWork'));
const LeaveCalendar = lazy(() => import('../../container/admin/LeaveCalendar'));
const Product = lazy(() => import('../../container/admin/Product'));

const ProjectsComponent = lazy(() => import('../../container/admin/Projects'));
const EmployeesComponent = lazy(() => import('../../container/admin/Employees'));
const TaskManagerComponent = lazy(() => import('../../container/admin/TaskManager'));
const TaskDetailsComponent = lazy(() => import('../../container/admin/TaskDetails'));
const DesignationsComponent = lazy(() => import('../../container/admin/Designations'));
const ProfileComponent = lazy(() => import('../../components/profile/Profile'));
const ChangePasswordComponent = lazy(() => import('../../components/profile/ChangePassword'));
const EmployeeProfileComponent = lazy(() => import('../../container/person/MyTasks'));
const ProgressComponent = lazy(() => import('../../container/admin/TaskProgress'));
const TodoListComponent = lazy(() => import('../../container/admin/TodoList'));
const TodayProgressComponent = lazy(() => import('../../container/admin/TodayProgress'));
const RequirementsComponent = lazy(() => import('../../components/jira-components/Requirements'));
const ComposeMailComponent = lazy(() => import('../../container/admin/ComposeMail'));
const UpdateDetailsComponent = lazy(() => import('../../components/profile/UpdateDetails'));
// const Teamgroup = lazy(() => import('../../container/admin/Teamgroup'));
const Teamgroup = lazy(() => import('../../container/admin/Teamgroup'));




const NotFound = lazy(() => import('../../container/pages/404'));

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Navigate to="task-manager" />} />
        <Route index path="/projects" element={<ProjectsComponent />} />
        <Route path="/product" element={<Product />} />
        <Route path="/employees" element={<EmployeesComponent />} />
        <Route path="/task-manager" element={<TaskManagerComponent />} />
        <Route path="/designations" element={<DesignationsComponent />} />
        <Route path="/requirements" element={<RequirementsComponent />} />
        <Route path="/todo" element={<TodoListComponent />} />
        <Route path="/today-progress" element={<TodayProgressComponent />} />
        <Route path="/compose-mail" element={<ComposeMailComponent />} />
        <Route path="/leavecalender" element={<LeaveCalendar />} />
        <Route path="/project-details/:id" element={<TaskDetailsComponent />} />
        <Route path="/employee-profile/:username/:id" element={<EmployeeProfileComponent />} />
        <Route path="/task-progress/:taskId/:task" element={<ProgressComponent />} />
        <Route path="/profile/*" element={<ProfileComponent />} />
        <Route path="/employeeDailyWork" element={<EmployeeDailyWork />} />
        <Route path="/change-password" element={<ChangePasswordComponent />} />
        <Route path="/update-details" element={<UpdateDetailsComponent />} />
        <Route path="/tasks" element={<TaskManagerComponent />} />
        <Route path="/tasks/status/:status" element={<TaskStatusManager />} />
        <Route path="/tasks/:id" element={<TaskDetails />} />
        <Route path="/leaverequestmanage" element={<LeaveRequestManage />} />
        <Route path="/addleave" element={<AddLeave />} />
        <Route path="/teamgroup" element={<Teamgroup />} />






        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);